<template>
  <main>
    <v-container class="booking-table">
      <v-toolbar flat class="main-header mb-6">
        <v-toolbar-title class="main-header__title">
          <h1>Camp Types</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items
          v-if="permissions.includes('store_api_admin-panel_camp-types')"
          class="main-header__contents"
        >
          <v-btn
            class="my-auto mx-1 radius-12"
            color="success"
            to="/camp-types/create"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">Add</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <hr class="mb-6" />
      <v-data-table
        :headers="campTypesTableHeaders"
        :loading="loadingDataTable"
        :items="campTypes"
        :mobile-breakpoint="zero"
        :items-per-page="200"
        hide-default-footer
        class="table"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell name text-center">
              {{ item ? item.order : "---" }}
            </td>
            <td class="table__cell text-center">
              <v-img
                height="50px"
                width="70px"
                class="radius-12"
                v-if="item.photo_url != null"
                :src="item ? item.photo_url : '--'"
              ></v-img>
              <span v-else>No Logo</span>
            </td>
            <td class="table__cell name text-center">
              {{ item ? item.name : "---" }}
            </td>
            <td class="table__cell text-center">
              {{ item.title || "---" }}
            </td>
            <td class="table__cell text-center">
              <span v-if="item.is_family == false">Family</span>
              <span v-else>Individual</span>
            </td>
            <td class="table__cell text-center">
              <read-more
                more-str="more"
                less-str="less"
                :text="item.description || '---'"
                :max-chars="20"
                class="mb-0 major-description m-b-0"
              ></read-more>
            </td>
            <td class="text-center">
              <v-btn
                v-if="
                  permissions.includes(
                    'index_api_admin-panel_camp-types_{camp_type}_sub-types'
                  )
                "
                color="primary"
                rounded
                large
                :to="`/camp-types/${item.id}/sub-types`"
                ><small>Sub Types</small></v-btn
              >
              <span v-else>---</span>
            </td>

            <td class="table__cell text-center">
              <router-link
                :to="{ name: 'campTypeEdit', params: { id: item.id } }"
                class="hovering mr-1 edit"
                v-if="
                  permissions.includes(
                    'update_api_admin-panel_camp-types_{camp_type}'
                  )
                "
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span
                v-if="
                  permissions.includes(
                    'destroy_api_admin-panel_camp-types_{camp_type}'
                  )
                "
                @click="handleDelete(item, index)"
                class="hovering delete"
              >
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
              <span v-else>---</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      campTypes: [],
      campTypesTableHeaders: [],
      loadingDataTable: false,
      zero: 0
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.busStopHeaders();
    // this.indexCampTypes();
  },
  methods: {
    indexCampTypes(query) {
      this.loadingDataTable = true;
      IndexData({ reqName: "camp-types", query })
        .then(res => {
          const { data } = res.data;
          this.campTypes = data;
          this.loadingDataTable = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    busStopHeaders() {
      const headersList = [
        "Order",
        "Pic",
        "Title",
        "Sub Title",
        "Category",
        "Description",
        "Sub Types",
        "Actions"
      ];
      this.campTypesTableHeaders = TableHeaders(headersList);
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/camp-types`,
            id: id
          })
            .then(() => {
              this.campTypes.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  },
  watch: {
    $route: {
      handler() {
        this.indexCampTypes();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
